module.exports = __webpack_public_path__ + "img/cq25d-title-icon.33b8148d.png";